<template>
  <div>
    <div class="loader" v-if="this.isLoading"></div>   
    <div class="loadertext" v-if="this.isLoading"> {{$t('loadingTxt')}}...</div>   
    <div class="main-wrapper" :class="{'blur-content': this.isLoading}">

        <!--begin::navbar-->
        <navbar-component></navbar-component>
        <!--end::navbar-->

      <div class="page-wrapper">

        <!--begin::content-->
        <div class="page-content">
          <div class="row">
            <div class="col-lg-12 col-xl-12 col-sm-12 col-xs-12 col-md-12">
              <div class="card">
                <div class="card-header">
                      <!-- <i class="link-icon float-start" data-feather="arrow-left"></i> -->
                       &nbsp;&nbsp;&nbsp;
                      <h6 class="card-title mb-0 float-start" style="padding-left: 25px">{{ $t("warehouse_system_code_create") }}</h6>
                      <button
                        class="btn btn-default btn-sm float-end"
                        @click="resetForm"
                        type="button"
                      >
                      <i class="link-icon" data-feather="repeat"></i>
                        {{ $t("resetFormTxt") }}
                      </button>
                </div>
                <div class="card-body">
      

                  <form
                    class="forms-sample"
                    @submit.prevent="submitData"
                    method="POST"
                  >
                
                    
                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">{{
                          $t('company_group_id')
                        }}</label>
                      </div>
                      <div class="col-lg-8">
                        
                        <v-select
                            :options="fetchCompanyGroup"
                            v-model="company_group"
                            label="company_group_description"
                            return-object
                            @search="asyncSearchCompanyGroup"
                          ></v-select>



                        <div v-if="errors.company_group_id">
                          <div
                            v-for="error in errors.company_group_id"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>
                    

                    
                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">{{
                          $t('customer_id')
                        }}</label>
                      </div>
                      <div class="col-lg-8">
                        
                        <v-select
                            :options="fetchCustomer"
                            v-model="customer"
                            label="customer_description"
                            return-object
                            @search="asyncSearchCustomer"
                          ></v-select>



                        <div v-if="errors.customer_id">
                          <div
                            v-for="error in errors.customer_id"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>


                    
                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">{{
                          $t('fulfillment')
                        }}</label>
                      </div>
                      <div class="col-lg-8">
                        
                        <v-select
                            :options="fetchFulfillment"
                            v-model="fulfillment"
                            label="fulfillment_description"
                            return-object
                            @search="asyncSearchFulfillment"
                          ></v-select>



                        <div v-if="errors.fulfillment_id">
                          <div
                            v-for="error in errors.fulfillment_id"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>




                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">{{
                          $t('category')
                        }}</label>
                      </div>
                      <div class="col-lg-8">
                        <input
                          type="text"
                          class="form-control"
                          id="category"
                          :placeholder="$t('category')"
                          v-model="forms.category"
                          required
                        />
                        <div v-if="errors.category">
                          <div
                            v-for="error in errors.category"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>


                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">{{
                          $t('code_type')
                        }}</label>
                      </div>
                      <div class="col-lg-8">
                        <input
                          type="text"
                          class="form-control"
                          id="code_type"
                          :placeholder="$t('code_type')"
                          v-model="forms.code_type"
                          required
                        />
                        <div v-if="errors.code_type">
                          <div
                            v-for="error in errors.code_type"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>



                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="code_id" class="col-form-label" style="padding-left: 25px">{{
                          $t('code_id')
                        }}</label>
                      </div>
                      <div class="col-lg-8">
                        <input
                          type="text"
                          class="form-control"
                          id="code_id"
                          :placeholder="$t('code_id')"
                          v-model="forms.code_id"
                          required
                        />
                        <div v-if="errors.code_id">
                          <div
                            v-for="error in errors.code_id"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-2">
                          <label for="code_description" class="col-form-label" style="padding-left: 25px">{{
                            $t('code_description')
                          }}</label>
                        </div>
                        <div class="col-lg-8">
                          <input
                            type="text"
                            class="form-control"
                            id="code_description"
                            :placeholder="$t('code_description')"
                            v-model="forms.code_description"
                            required
                          />
                          <div v-if="errors.code_description">
                            <div
                              v-for="error in errors.code_description"
                              :key="error"
                              class="alert alert-primary"
                              role="alert"
                            >
                              <i data-feather="alert-circle"></i>
                              {{ error }}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="row mb-3">
                        <div class="col-lg-2">
                          <label for="outer_code" class="col-form-label" style="padding-left: 25px">{{
                            $t('outer_code')
                          }}</label>
                        </div>
                        <div class="col-lg-8">
                          <input
                            type="text"
                            class="form-control"
                            id="outer_code"
                            :placeholder="$t('outer_code')"
                            v-model="forms.outer_code"
                            
                          />
                          <div v-if="errors.outer_code">
                            <div
                              v-for="error in errors.outer_code"
                              :key="error"
                              class="alert alert-primary"
                              role="alert"
                            >
                              <i data-feather="alert-circle"></i>
                              {{ error }}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="row mb-3">
                    <div class="col-lg-2">
                      <label for="show_sequence" class="col-form-label" style="padding-left: 25px">{{
                        $t('show_sequence')
                      }}</label>
                    </div>
                    <div class="col-lg-8">
                      <input
                        type="number"
                        class="form-control"
                        id="show_sequence"
                        :placeholder="$t('show_sequence')"
                        v-model="forms.show_sequence"
                        required
                      />
                      <div v-if="errors.show_sequence">
                        <div
                          v-for="error in errors.show_sequence"
                          :key="error"
                          class="alert alert-primary"
                          role="alert"
                        >
                          <i data-feather="alert-circle"></i>
                          {{ error }}
                        </div>
                      </div>
                    </div>
                      </div>

                      <div class="row mb-3">
                        <div class="col-lg-2">
                          <label for="active_flag" class="col-form-label" style="padding-left: 25px">{{
                            $t('active_flag')
                          }}</label>
                        </div>
                        <div class="col-lg-8">
                          <input
                            type="text"
                            class="form-control"
                            id="active_flag"
                            :placeholder="$t('active_flag')"
                            v-model="forms.active_flag"
                            maxlength="2"
                          />
                          <div v-if="errors.active_flag">
                            <div
                              v-for="error in errors.active_flag"
                              :key="error"
                              class="alert alert-primary"
                              role="alert"
                            >
                              <i data-feather="alert-circle"></i>
                              {{ error }}
                            </div>
                          </div>
                        </div>
                      </div>


                    <div class="row mb-3">
                        <div class="col-lg-2">
                          <label for="default_flag" class="col-form-label" style="padding-left: 25px">{{
                            $t('default_flag')
                          }}</label>
                        </div>
                        <div class="col-lg-8">
                          <input
                            type="text"
                            class="form-control"
                            id="default_flag"
                            :placeholder="$t('default_flag')"
                            v-model="forms.default_flag"
                            maxlength="2"
                          />
                          <div v-if="errors.default_flag">
                            <div
                              v-for="error in errors.default_flag"
                              :key="error"
                              class="alert alert-primary"
                              role="alert"
                            >
                              <i data-feather="alert-circle"></i>
                              {{ error }}
                            </div>
                          </div>
                        </div>
                      </div>


                      <div class="row mb-3">
                        <div class="col-lg-2">
                          <label for="udf01" class="col-form-label" style="padding-left: 25px">{{
                            $t('udf01')
                          }}</label>
                        </div>
                        <div class="col-lg-8">
                          <input
                            type="text"
                            class="form-control"
                            id="udf01"
                            :placeholder="$t('udf01')"
                            v-model="forms.udf01"
                          />
                          <div v-if="errors.udf01">
                            <div
                              v-for="error in errors.udf01"
                              :key="error"
                              class="alert alert-primary"
                              role="alert"
                            >
                              <i data-feather="alert-circle"></i>
                              {{ error }}
                            </div>
                          </div>
                        </div>
                      </div>
                  

                      <div class="row mb-3">
                        <div class="col-lg-2">
                          <label for="udf02" class="col-form-label" style="padding-left: 25px">{{
                            $t('udf02')
                          }}</label>
                        </div>
                        <div class="col-lg-8">
                          <input
                            type="text"
                            class="form-control"
                            id="udf02"
                            :placeholder="$t('udf02')"
                            v-model="forms.udf02"
                          />
                          <div v-if="errors.udf02">
                            <div
                              v-for="error in errors.udf02"
                              :key="error"
                              class="alert alert-primary"
                              role="alert"
                            >
                              <i data-feather="alert-circle"></i>
                              {{ error }}
                            </div>
                          </div>
                        </div>
                      </div>
            
                      <div class="row mb-3">
                        <div class="col-lg-2">
                          <label for="udf03" class="col-form-label" style="padding-left: 25px">{{
                            $t('udf03')
                          }}</label>
                        </div>
                        <div class="col-lg-8">
                          <input
                            type="text"
                            class="form-control"
                            id="udf03"
                            :placeholder="$t('udf03')"
                            v-model="forms.udf03"
                          />
                          <div v-if="errors.udf03">
                            <div
                              v-for="error in errors.udf03"
                              :key="error"
                              class="alert alert-primary"
                              role="alert"
                            >
                              <i data-feather="alert-circle"></i>
                              {{ error }}
                            </div>
                          </div>
                        </div>
                      </div>
   
                      <div class="row mb-3">
                        <div class="col-lg-2">
                          <label for="udf04" class="col-form-label" style="padding-left: 25px">{{
                            $t('udf04')
                          }}</label>
                        </div>
                        <div class="col-lg-8">
                          <input
                            type="text"
                            class="form-control"
                            id="udf04"
                            :placeholder="$t('udf04')"
                            v-model="forms.udf04"
                          />
                          <div v-if="errors.udf04">
                            <div
                              v-for="error in errors.udf04"
                              :key="error"
                              class="alert alert-primary"
                              role="alert"
                            >
                              <i data-feather="alert-circle"></i>
                              {{ error }}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="row mb-3">
                        <div class="col-lg-2">
                          <label for="udf05" class="col-form-label" style="padding-left: 25px">{{
                            $t('udf05')
                          }}</label>
                        </div>
                        <div class="col-lg-8">
                          <input
                            type="text"
                            class="form-control"
                            id="udf05"
                            :placeholder="$t('udf05')"
                            v-model="forms.udf05"
                          />
                          <div v-if="errors.udf05">
                            <div
                              v-for="error in errors.udf05"
                              :key="error"
                              class="alert alert-primary"
                              role="alert"
                            >
                              <i data-feather="alert-circle"></i>
                              {{ error }}
                            </div>
                          </div>
                        </div>
                      </div>

                   
                      <div class="row mb-3">
                        <div class="col-lg-2">
                          <label for="wsc01" class="col-form-label" style="padding-left: 25px">{{
                            $t('billing_customer_c01')
                          }}</label>
                        </div>
                        <div class="col-lg-8">
                          <input
                            type="text"
                            class="form-control"
                            id="wsc01"
                            :placeholder="$t('billing_customer_c01')"
                            v-model="forms.wsc01"
                          />
                          <div v-if="errors.wsc01">
                            <div
                              v-for="error in errors.wsc01"
                              :key="error"
                              class="alert alert-primary"
                              role="alert"
                            >
                              <i data-feather="alert-circle"></i>
                              {{ error }}
                            </div>
                          </div>
                        </div>
                      </div>

   
              
                      <div class="row mb-3">
                        <div class="col-lg-2">
                          <label for="wsc02" class="col-form-label" style="padding-left: 25px">{{
                            $t('billing_customer_c02')
                          }}</label>
                        </div>
                        <div class="col-lg-8">
                          <input
                            type="text"
                            class="form-control"
                            id="wsc02"
                            :placeholder="$t('billing_customer_c02')"
                            v-model="forms.wsc02"
                          />
                          <div v-if="errors.wsc02">
                            <div
                              v-for="error in errors.wsc02"
                              :key="error"
                              class="alert alert-primary"
                              role="alert"
                            >
                              <i data-feather="alert-circle"></i>
                              {{ error }}
                            </div>
                          </div>
                        </div>
                      </div>
         
         
                      <div class="row mb-3">
                        <div class="col-lg-2">
                          <label for="wsc03" class="col-form-label" style="padding-left: 25px">{{
                            $t('billing_customer_c03')
                          }}</label>
                        </div>
                        <div class="col-lg-8">
                          <input
                            type="text"
                            class="form-control"
                            id="wsc03"
                            :placeholder="$t('billing_customer_c03')"
                            v-model="forms.wsc03"
                          />
                          <div v-if="errors.wsc03">
                            <div
                              v-for="error in errors.wsc03"
                              :key="error"
                              class="alert alert-primary"
                              role="alert"
                            >
                              <i data-feather="alert-circle"></i>
                              {{ error }}
                            </div>
                          </div>
                        </div>
                      </div>


                    <div class="row mb-3">
                        <div class="col-lg-2">
                          <label for="wsc04" class="col-form-label" style="padding-left: 25px">{{
                            $t('billing_customer_c04')
                          }}</label>
                        </div>
                        <div class="col-lg-8">
                          <input
                            type="text"
                            class="form-control"
                            id="wsc04"
                            :placeholder="$t('billing_customer_c04')"
                            v-model="forms.wsc04"
                          />
                          <div v-if="errors.wsc04">
                            <div
                              v-for="error in errors.wsc04"
                              :key="error"
                              class="alert alert-primary"
                              role="alert"
                            >
                              <i data-feather="alert-circle"></i>
                              {{ error }}
                            </div>
                          </div>
                        </div>
                      </div>


                    <div class="row mb-3">
                        <div class="col-lg-2">
                          <label for="wsc05" class="col-form-label" style="padding-left: 25px">{{
                            $t('billing_customer_c05')
                          }}</label>
                        </div>
                        <div class="col-lg-8">
                          <input
                            type="text"
                            class="form-control"
                            id="wsc05"
                            :placeholder="$t('billing_customer_c05')"
                            v-model="forms.wsc05"
                          />
                          <div v-if="errors.wsc05">
                            <div
                              v-for="error in errors.wsc05"
                              :key="error"
                              class="alert alert-primary"
                              role="alert"
                            >
                              <i data-feather="alert-circle"></i>
                              {{ error }}
                            </div>
                          </div>
                        </div>
                      </div>



                      <div class="row mb-3">
                        <div class="col-lg-2">
                          <label for="wsc06" class="col-form-label" style="padding-left: 25px">{{
                            $t('billing_customer_c06')
                          }}</label>
                        </div>
                        <div class="col-lg-8">
                          <input
                            type="text"
                            class="form-control"
                            id="wsc06"
                            :placeholder="$t('billing_customer_c06')"
                            v-model="forms.wsc06"
                          />
                          <div v-if="errors.wsc06">
                            <div
                              v-for="error in errors.wsc06"
                              :key="error"
                              class="alert alert-primary"
                              role="alert"
                            >
                              <i data-feather="alert-circle"></i>
                              {{ error }}
                            </div>
                          </div>
                        </div>
                      </div>                      

                      <div class="row mb-3">
                        <div class="col-lg-2">
                          <label for="wsc07" class="col-form-label" style="padding-left: 25px">{{
                            $t('billing_customer_c07')
                          }}</label>
                        </div>
                        <div class="col-lg-8">
                          <input
                            type="text"
                            class="form-control"
                            id="wsc07"
                            :placeholder="$t('billing_customer_c07')"
                            v-model="forms.wsc07"
                          />
                          <div v-if="errors.wsc07">
                            <div
                              v-for="error in errors.wsc07"
                              :key="error"
                              class="alert alert-primary"
                              role="alert"
                            >
                              <i data-feather="alert-circle"></i>
                              {{ error }}
                            </div>
                          </div>
                        </div>
                      </div>
                   
                      <div class="row mb-3">
                        <div class="col-lg-2">
                          <label for="wsc08" class="col-form-label" style="padding-left: 25px">{{
                            $t('billing_customer_c08')
                          }}</label>
                        </div>
                        <div class="col-lg-8">
                          <input
                            type="text"
                            class="form-control"
                            id="wsc08"
                            :placeholder="$t('billing_customer_c08')"
                            v-model="forms.wsc08"
                          />
                          <div v-if="errors.wsc08">
                            <div
                              v-for="error in errors.wsc08"
                              :key="error"
                              class="alert alert-primary"
                              role="alert"
                            >
                              <i data-feather="alert-circle"></i>
                              {{ error }}
                            </div>
                          </div>
                        </div>
                      </div>



                    <div class="row mb-3">
                        <div class="col-lg-2">
                          <label for="wsc09" class="col-form-label" style="padding-left: 25px">{{
                            $t('billing_customer_c09')
                          }}</label>
                        </div>
                        <div class="col-lg-8">
                          <input
                            type="text"
                            class="form-control"
                            id="wsc09"
                            :placeholder="$t('billing_customer_c09')"
                            v-model="forms.wsc09"
                          />
                          <div v-if="errors.wsc09">
                            <div
                              v-for="error in errors.wsc09"
                              :key="error"
                              class="alert alert-primary"
                              role="alert"
                            >
                              <i data-feather="alert-circle"></i>
                              {{ error }}
                            </div>
                          </div>
                        </div>
                      </div>


                      <div class="row mb-3">
                        <div class="col-lg-2">
                          <label for="wsc10" class="col-form-label" style="padding-left: 25px">{{
                            $t('billing_customer_c10')
                          }}</label>
                        </div>
                        <div class="col-lg-8">
                          <input
                            type="text"
                            class="form-control"
                            id="wsc10"
                            :placeholder="$t('billing_customer_c10')"
                            v-model="forms.wsc10"
                          />
                          <div v-if="errors.wsc10">
                            <div
                              v-for="error in errors.wsc10"
                              :key="error"
                              class="alert alert-primary"
                              role="alert"
                            >
                              <i data-feather="alert-circle"></i>
                              {{ error }}
                            </div>
                          </div>
                        </div>
                      </div>



                    <div class="card-footer">
                      <button
                        class="
                          btn btn-warning
                          text-black
                          fw-bolder
                          btn-icon-text
                        "
                        @click="backForm"
                        type="button"
                      >
                        <i class="link-icon" data-feather="arrow-left"></i>
                        {{ $t("backMess") }}
                      </button>
                      &nbsp;&nbsp;&nbsp;
                      <button class="btn btn-primary float-end btn-sm" type="submit">
                           <i class="link-icon" data-feather="save"></i>
                        {{ $t("submitFormTxt") }}
                      </button>
                    </div>
                  </form>
                </div>
              </div> <!--end::card-->
            </div>
          </div>
        </div>
        <!--end::content-->

        <!--begin::footer-->
        <footer-component></footer-component>
        <!--end::footer-->
      </div>
    </div>
  </div>
</template>


<script>
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";

export default {
  name: "WarehouseSystemCodeAdd",
  props: {},
  components: {
    "navbar-component": navbarComponent,
    "footer-component": footerComponent,
  },
  data() {
    return {
      permision_role:[],
      isLoading: false,
      maxToasts: 100,
      position: "up right",
      closeBtn: true,
      errors: [],
      fetchCompanyGroup:[],
      fetchCustomer:[],
      fetchFulfillment:[],
      company_group:"",
      customer:"",
      fulfillment:"",
      userData: "",
      userRole: "",
      companyCode: "",
      forms: { warehouse_system_code_id: "", company_group_id: "",fulfillment_id:"" , customer_id:"", category:"", code_type:"", code_id:"", code_description:"", outer_code:"", show_sequence:"", active_flag:"", default_flag:"",  udf01:"", udf02:"", udf03:"", udf04:"", udf05:"", wsc01:"", wsc02:"", wsc03:"", wsc04:"", wsc05:"", wsc06:"", wsc07:"", wsc08:"", wsc09:"", wsc10:"", company_group:"", customer:"",fulfillment:""},
    };
  },
  watch: {},
  methods: {

    asyncSearchFulfillment(){

      let company_group_id = null
      if(typeof this.company_group == "object"){
        company_group_id = this.company_group.company_group_id
      }

      const baseURI = this.$settings.endPointBilling + "dashboard/fulfillment/get-data?download=all&company_group_id="+company_group_id;
     
      return this.$http
        .get(
          baseURI,{ timeout: 10000 }
        )
        .then((response) => {
           this.fetchFulfillment=response.data.datas;
        }).catch(error => {

          if(error.code == "ECONNABORTED"){
            this.error("Please Check Your Internet Connection");
          }

        });
    },

    asyncSearchCompanyGroup(){

      const baseURI = this.$settings.endPointBilling + "dashboard/company-group?download=all";
     
      return this.$http
        .get(
          baseURI,{ timeout: 10000 }
        )
        .then((response) => {
           this.fetchCompanyGroup=response.data.datas;
        }).catch(error => {

          if(error.code == "ECONNABORTED"){
            this.error("Please Check Your Internet Connection");
          }

        });
    },

    asyncSearchCustomer(){

      let company_group_id = null
      if(typeof this.company_group == "object"){
        company_group_id = this.company_group.company_group_id
      }
      

      const baseURI = this.$settings.endPointBilling + "dashboard/customer/get-data?download=all&company_group_id="+company_group_id;
     
      return this.$http
        .get(
          baseURI,{ timeout: 10000 }
        )
        .then((response) => {
           this.fetchCustomer=response.data.datas;
        }).catch(error => {

          if(error.code == "ECONNABORTED"){
            this.error("Please Check Your Internet Connection");
          }

        });
    },


    resetForm() {
      this.forms.company_group              = "";
      this.forms.warehouse_system_code_id   = "";
      this.forms.company_group_id           = "";
      this.forms.customer_id                = "";
      this.forms.fulfillment_id             = "";
      this.forms.fulfillment                = "";
      this.forms.category                   = "";
      this.forms.code_type                  = "";
      this.forms.code_id                    = "";
      this.forms.outer_code                 = "";
      this.forms.show_sequence              = 0;
      this.forms.active_flag                = "";
      this.forms.default_flag               = "";
      this.forms.udf01                      = "";
      this.forms.udf02                      = "";
      this.forms.udf03                      = "";
      this.forms.udf04                      = "";
      this.forms.udf05                      = "";
      this.forms.wsc01                      = "";
      this.forms.wsc02                      = "";
      this.forms.wsc03                      = "";
      this.forms.wsc04                      = "";
      this.forms.wsc05                      = "";
      this.forms.wsc06                      = "";
      this.forms.wsc07                      = "";
      this.forms.wsc08                      = "";
      this.forms.wsc09                      = "";
      this.forms.wsc10                      = "";
      this.company_group                    = ""
      this.customer                         = ""
      this.fulfillment                      = ""

    },

    fetchIt() {
      const userDatas     = this.$getUserInfo();
      this.userData       = userDatas.sub;
      this.userRole       = userDatas.sub.role;
      // this.permision_role = userDatas.sub.permision_role;
      let rolePermision = [];
      userDatas.sub.permision_role.forEach(function(permision){
        if(permision.permission.controller == 'BillingWarehouseSystemCodeController'){
          rolePermision = permision;
        }
      });

      if(!rolePermision.method_create){
        this.$router.push("/authorized-error");
      }
      this.permision_role = rolePermision;

    },

    backForm() {
       window.location.href = "/billing-warehouse-system-code";
    },


    submitData() {
          this.isLoading = true;
       
          if(typeof this.company_group == "object"){
            this.forms.company_group_id = this.company_group.company_group_id
          }else{
            this.forms.company_group_id = ""
          }
       
          if(typeof this.customer == "object"){
            this.forms.customer_id = this.customer.customer_id
          }else{
            this.forms.customer_id = ""
          }
            
          if(typeof this.fulfillment == "object"){
            this.forms.fulfillment_id = this.fulfillment.fulfillment_id
          }else{
            this.forms.fulfillment_id = ""
          }

          const baseURI  =  this.$settings.endPointBilling+"dashboard/warehouse-system-code/create";
          this.$http.post(baseURI,this.forms,{ timeout: 10000 }).then((response) => {
              this.loading();
              if(response.data.status === 200) {
              //this.resetForm();
                  this.isLoading = false;
                  this.errors = [];
                  //console.log(response.data.datas.user_id);
                  var params = this.$onRandom(response.data.datas.warehouse_system_code_id);
                    window.location.href = "/billing-warehouse-system-code/detail/" + params + "?status=200&msg=Successfully";
                  // this.success('Berhasil');
              }else{
                  this.isLoading = false;
                  this.errors = response.data.errors;
                  this.resultError(response.data.errors);
              }
          }).catch(error => {
                this.loading();
                this.isLoading = false;
               
        if(error.code == "ECONNABORTED"){
            this.error(this.$t("check_internet_connection_txt"));
            
        }else{

            if (error.response) {
                if(error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                }else if (error.response.status === 401) {
                    this.logout();
                } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                }else if (error.response.status === 500) {
                    this.$router.push('/server-error');
                }else{
                    this.$router.push('/page-not-found');
                }
            }

        }
              //this.resetForm();
          });
    },


      logout(){

          const baseURI = this.$settings.endPoint + "user/logout";
          this.$http.get(baseURI, { timeout: 10000 }).then((response) => {
              
          console.log(response);

          });

          this.$logoutUser();
          window.location.href = '/';
      },
      
    fade(sType) {
      this.isLoading = sType;
    },

    loading() {
      this.fade(true);
      setTimeout(() => {
        this.fade(false);
      }, 1000); // hide the message after 3 seconds
    },

    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    success(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "success",
        title: kata,
      });
    },

    error(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "error",
        title: kata,
      });
    },
  },
  events: {},
  created: function () {},
  mounted() {
    this.fetchIt();
  },
};
</script>
<style scoped>

</style>